import React from 'react';

import { reportActions } from 'actions/ReportActions';
import { reportStore } from 'stores/ReportStore';
import { criteriaStore } from 'stores/CriteriaStore';

import { checkIfSquaredJsx } from 'utils/Utilities';

import Draggable from 'draggable';
import _ from 'lodash';
import { Subscript } from 'utils/Subscript';
import ChartComponent from 'components/Report/Chart';
import standardsConfig from 'js/standards.config';
import Table from 'components/Report/Table';

const SingleLine = (props) => {
  const { value, label, jsxLabel } = props;
  let renderedLabel;
  let renderedValue;

  if (jsxLabel && jsxLabel === 'NO SEISMIC SPECTRUM') {
    renderedLabel = 'Note';
    renderedValue = (
      <span>
        Design and MCE<sub>R</sub> spectrum data not available for this location.
      </span>
    );
  } else {
    renderedLabel = jsxLabel ? jsxLabel : label;
    renderedValue = value === 'Case Study Required' ? '' : checkIfSquaredJsx(value);
  }

  return (
    <div className='details-popup-singleLine'>
      <div>
        <span>{renderedLabel}</span>
      </div>
      <div>
        <span>{renderedValue}</span>
      </div>
    </div>
  );
};

class GridCell extends React.Component {
  render() {
    let subscript = new Subscript(this.props.label);
    let subscript_component = subscript.output();

    return (
      <div className='details-popup-grid-cell'>
        <div className='grid-cell-label'>{subscript_component}</div>
        <div className='grid-cell-value'>
          <span>{this.props.value}</span>
        </div>
      </div>
    );
  }
}

class Grid extends React.Component {
  render() {
    let cells = _.map(this.props.items, (item, idx) => {
      return <GridCell key={idx} {...item} />;
    });
    return (
      <div className='details-popup-grid'>
        <div className='details-popup-grid-title'>{this.props.label}</div>
        <div className='grid-container'>{cells}</div>
      </div>
    );
  }
}

class StateNoteComponent extends React.Component {
  render() {
    return (
      <div className='details-popup-singleLine'>
        <div className='grid-cell-label'>
          <span>{this.props.label}</span>
        </div>
        <div className='grid-cell-value'>
          <span>{this.props.note.startingText}</span>
          <a href={this.props.note.hyperlinkUrl} target='_blank'>
            {this.props.note.hyperlinkText}
          </a>
          <span>{this.props.note.endingText}</span>
        </div>
      </div>
    );
  }
}

class DataSource extends React.Component {
  render() {
    let additionalText = null;
    if (this.props.dataSource.text) {
      additionalText = (
        <span>
          {this.props.dataSource.text}
          <br />
        </span>
      );
    }

    if (this.props.dataSource.hyperlinkUrl === '') {
      return (
        <div className='details-popup-singleLine'>
          <div className='grid-cell-label'>
            <span>Data Source</span>
          </div>
          <div className='grid-cell-value'>
            {additionalText}
            <span>{this.props.dataSource.hyperlinkText}</span>
          </div>
        </div>
      );
    } else {
      return (
        <div className='details-popup-singleLine'>
          <div className='grid-cell-label'>
            <span>Data Source</span>
          </div>
          <div className='grid-cell-value'>
            {additionalText}
            <a href={this.props.dataSource.hyperlinkUrl} target='_blank'>
              {this.props.dataSource.hyperlinkText}
            </a>
          </div>
        </div>
      );
    }
  }
}

class NoteComponent extends React.Component {
  render() {
    const standardsVersion = criteriaStore.getState().standardsVersion;
    let label = this.props.jsxLabel ? this.props.jsxLabel : this.props.note;

    if (!this.props.hyperlinkUrl || this.props.hyperlinkUrl === '') {
      if (standardsVersion === '7-22' && label && label.includes('Special Wind Region')) {
        const splitText = label.split(' -- ');
        const pre = splitText[0];
        const post = splitText[1];
        label = (
          <span>
            <span style={{ color: 'red', fontWeight: 'bold' }}>{pre}</span> -- {post}
          </span>
        );
      } else {
        label = <span>{label}</span>;
      }
      return <div className='details-popup-singleLine'>{label}</div>;
    } else {
      return (
        <div className='details-popup-singleLine'>
          <span>
            {label} <br />
            <a href={this.props.hyperlinkUrl} target='_blank'>
              {this.props.hyperlinkText}
            </a>
          </span>
        </div>
      );
    }
  }
}

export class DetailsPopup extends React.Component {
  constructor(props) {
    super(props);
    reportStore.listen(this.storeUpdated.bind(this));
    this.state = reportStore.getState();
  }

  storeUpdated() {
    this.setState(reportStore.getState());
  }

  componentDidUpdate() {
    this.state = this.props;
  }

  closePopup() {
    reportActions.closePopup();
  }

  addDetail(deets, i) {
    switch (deets.type) {
      case 'singleLine':
        return <SingleLine key={i} {...deets} />;
      case 'grid':
        return <Grid key={i} {...deets} />;
      case 'table':
        return <Table key={i} {...deets} />;
      case 'chart':
        return <ChartComponent key={i} {...deets} />;
      case 'stateNote':
        return <StateNoteComponent key={i} {...deets} />;
      case 'note':
        return <NoteComponent key={i} {...deets} />;
      case 'dataSource':
        return <DataSource key={i} {...deets} />;
      default:
        return null;
    }
  }

  render() {
    const { showLoad, detailsPopupVisible } = this.state;
    const standardsVersion = criteriaStore.getState().standardsVersion;

    const largePopup = standardsVersion === '7-22' && showLoad && showLoad.label === 'Snow';
    const isSeismic = showLoad.label === 'Seismic';
    const details = showLoad.hasOwnProperty('details') ? showLoad.details.map(this.addDetail) : [];
    return (
      <Draggable axis='both' handle='.popup-header' bounds='#map'>
        <div
          id='detailsPopupDraggable'
          className={`draggable-popup ${detailsPopupVisible ? '' : 'hidden'} ${isSeismic ? 'seismic-width' : ''}${
            largePopup ? ' large' : ''
          }`}
        >
          <div className='popup-header blue darken-3'>
            <span>{`${showLoad.label} Details`}</span>
            <span className='details-popup-close-icon' onClick={this.closePopup} />
          </div>
          <div className='popup-body padding'>{details}</div>
        </div>
      </Draggable>
    );
  }
}
